import { create } from 'zustand';
import { type AiWorkbenchAction } from '@/api/ai';
import { generateCorrelationId } from '@/shared/correlation';

export type MessageRole = 'user' | 'assistant';

export type ChatMessage = {
  id: string;
  role: MessageRole;
  content: string;
  timestamp: string;
  correlationId?: string;
  uiAction?: AiWorkbenchAction | null;
  suggestedPrompts?: string[] | null;
};

function generateId(): string {
  return `msg-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
}

type ChatState = {
  sessionId: string | null;
  messages: ChatMessage[];
  correlationId: string | null;
  isSending: boolean;

  append: (msg: Omit<ChatMessage, 'id'>) => void;
  setSession: (id: string) => void;
  newCorrelation: () => string;
  setIsSending: (v: boolean) => void;
  reset: () => void;
};

export const useChatStore = create<ChatState>((set) => ({
  sessionId: null,
  messages: [],
  correlationId: null,
  isSending: false,

  append: (msg) => {
    const message: ChatMessage = { id: generateId(), ...msg };
    set((s) => ({ messages: [...s.messages, message] }));
  },

  setSession: (id) => set({ sessionId: id }),

  newCorrelation: () => {
    const id = generateCorrelationId();
    set({ correlationId: id });
    return id;
  },

  setIsSending: (v) => set({ isSending: v }),

  reset: () =>
    set({
      sessionId: null,
      messages: [],
      correlationId: null,
      isSending: false,
    }),
}));
